import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const RenterIcon: React.FC<SvgIconProps> = props => {
  return (
    <SvgIcon {...props}>
      <path d='M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM12 14.2C13.5 13.8 15 12.9 16.1 11.5L17.8 12.5C16.3 14.3 14.2 15.4 12 15.8V19H8V15.8C5.8 15.4 3.7 14.3 2.2 12.5L3.9 11.5C5 12.9 6.5 13.8 8 14.2V7H12V14.2Z' />
    </SvgIcon>
  );
};
